export const PRODUCT_NAME = 'Vennevent';

export function formatDocumentTitle(pageTitle?: string | null) {
  const normalizedTitle = pageTitle?.trim();
  if (!normalizedTitle || normalizedTitle === PRODUCT_NAME) return PRODUCT_NAME;
  return `${normalizedTitle} · ${PRODUCT_NAME}`;
}
